import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/*
  Радіуси button / control / card — наші токени теми (styles.css застосунків).
  Без цього twMerge не знає, що `rounded-button` і `rounded-md` конфліктують,
  і лишає обидва — переміг би випадковий порядок правил у CSS.
*/
const twMerge = extendTailwindMerge({ extend: { theme: { radius: ['button', 'control', 'card'] } } });

/** Єдиний спосіб склеювати класи. Прямий шаблонний рядок з класами — антипатерн. */
export function cn(...inputs: ClassValue[]): string {
	return twMerge(clsx(inputs));
}
